import React from "react";
import { motion } from "framer-motion";
import { ShieldAlert, Flame } from "lucide-react";

// Pure CSS/Tailwind iPhone mockup showing a fake DocLove analysis report.
export default function PhoneMockup() {
  return (
    <motion.div
      animate={{ y: [0, -14, 0] }}
      transition={{ repeat: Infinity, duration: 4.5, ease: "easeInOut" }}
      className="relative w-full max-w-[290px] mx-auto"
    >
      <div className="relative rounded-[3rem] border-8 border-zinc-800 bg-zinc-950 aspect-[19/40] shadow-2xl overflow-hidden">
        {/* notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-zinc-800 rounded-b-2xl z-10" />
        {/* glow */}
        <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-56 h-56 rounded-full bg-pink-600/30 blur-3xl" />
        <div className="relative h-full px-4 pt-10 pb-4 flex flex-col gap-3 overflow-hidden">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-pink-500 to-purple-600" />
            <div>
              <p className="text-[11px] font-bold text-white leading-none">Sarah</p>
              <p className="text-[8px] text-zinc-500">Analyse · aujourd'hui</p>
            </div>
          </div>

          {/* health score ring */}
          <div className="rounded-2xl bg-zinc-900 border border-white/5 p-3 flex flex-col items-center">
            <div className="relative w-24 h-24">
              <svg viewBox="0 0 100 100" className="w-full h-full -rotate-90">
                <circle cx="50" cy="50" r="42" fill="none" stroke="#27272a" strokeWidth="9" />
                <circle cx="50" cy="50" r="42" fill="none" stroke="#f59e0b" strokeWidth="9" strokeLinecap="round"
                  strokeDasharray={264} strokeDashoffset={264 - 264 * 0.62} style={{ filter: "drop-shadow(0 0 6px #f59e0b)" }} />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="font-display text-3xl font-black text-amber-400">62</span>
                <span className="text-[7px] uppercase tracking-widest text-zinc-500">santé</span>
              </div>
            </div>
            <p className="text-[9px] text-zinc-400 mt-1 text-center">Mitigé — vigilance recommandée</p>
          </div>

          {/* red flags */}
          <div className="rounded-2xl bg-red-500/10 border border-red-500/25 p-3">
            <div className="flex items-center gap-1.5 mb-1.5">
              <ShieldAlert size={12} className="text-red-400" />
              <span className="text-[9px] font-bold uppercase tracking-wider text-red-400">2 red flags</span>
            </div>
            <div className="flex flex-wrap gap-1.5">
              {["Hot & cold", "Réponses tardives"].map((t) => (
                <span key={t} className="text-[8px] font-semibold text-red-200 bg-red-500/15 rounded-full px-2 py-0.5">🚩 {t}</span>
              ))}
            </div>
          </div>

          {/* rizz */}
          <div className="rounded-2xl bg-zinc-900 border border-white/5 p-3 flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-pink-500/15 flex items-center justify-center">
              <Flame size={15} className="text-pink-400" />
            </div>
            <div className="flex-1">
              <p className="text-[9px] text-zinc-400">Rizz Score</p>
              <div className="h-1.5 rounded-full bg-zinc-800 mt-1 overflow-hidden">
                <div className="h-full rounded-full bg-gradient-to-r from-pink-500 to-purple-500" style={{ width: "74%" }} />
              </div>
            </div>
            <span className="font-display text-lg font-black bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent">B+</span>
          </div>

          <div className="rounded-full bg-pink-500 text-white text-[10px] font-bold text-center py-2.5 shadow-[0_0_18px_rgba(236,72,153,0.5)]">
            Voir 3 réponses ✨
          </div>
        </div>
      </div>
    </motion.div>
  );
}
